<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    />
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="search.provinceId"
              filterable
              clearable
              placeholder="请选择省区"
              style="width:100%"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.label"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="search.name"
              placeholder="请输入人员名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="search.year"
              placeholder="请选择年份"
              style="width:100%"
            >
              <el-option
                v-for="item in yearOptions"
                :key="item.label"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="search.month"
              placeholder="请选择年份"
              style="width:100%"
            >
              <el-option
                v-for="item in monthOptions"
                :key="item.label"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
            <el-button
              v-if="isExport"
              type="warning"
              @click="exportExcel()"
            >
              导出
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <el-table
        id="work-table"
        v-loading="loading"
        :data="workData"
        border
        highlight-current-row
        :span-method="workSpanMethod"
        :header-cell-style="{background:themeBg()}"
        class="public-table"
        style="width: 100%;"
        :height="tableHeight"
      >
        <el-table-column
          v-for="(column, index) in tableColumns"
          :key="index"
          resizable
          :width="column.width ? column.width : 'auto'"
          :fixed="index <= columnIndex"
          :label="column.label"
          :prop="column.prop"
          header-align="center"
          :align="index > columnIndex ? 'center' : 'left'"
        >
          <template slot-scope="scope">
            <span>{{ scope.row[column.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// 文件保存控件
import FileSaver from 'file-saver'
// EXCEL处理控件
import XLSX from 'xlsx'
// 合并表格tableMergeMixin
import tableMergeMixin from '@/mixin/tableMergeMixin'
// 权限验证
import checkPermission from '@/utils/permission'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
// 数据请求
import { loadOutsideWorkLogListDataApi } from '@/api/outsideUserStatistics'
export default {
  name: 'OutsideWorkLog',
  components: {
  },
  mixins: [tableMergeMixin],
   data () {
    return {
      loading: false,
      // 查询条件
      search: {
        name: '',
        year: '',
        month: '',
        provinceId: ''
      },
      isExport: false,
      yearOptions: [],
      monthOptions: [],
      provinceOptions: [],
      tableHeight: '600px',
      columnIndex: 5,
      workData: [], // 列表数据源
      workRowMergeArray: [], // 合并行处理数据
      workNeedMergeArray: ['provinceNames', 'cityNames', 'countyNames', 'userName', 'workDay'], // 预算表有合并项的列
      tableColumns: [], // 数据列表列字段
      // 数据表固定列
      fixedColumns: [
        { prop: 'provinceNames', label: '省区', width: 70 },
        { prop: 'cityNames', label: '城市', width: 70 },
        { prop: 'countyNames', label: '区县', width: 70 },
        { prop: 'userName', label: '人员', width: 70 },
        { prop: 'workDay', label: '本月痕迹天数', width: 110},
        { prop: 'type', label: '类型', width: 80}
      ]
    }
  },
   created () {
    // 初始化主列表Table列
    for(let i = 1; i<= 31; i++){
      this.fixedColumns.push({prop: 'day'+i, label: i+'日', filterColumn: 'r.user_name', width: 60})
    }
    this.fixedColumns.push({prop: 'workTotal', label: '合计', filterColumn: 'r.user_name', width: 60})
    // 设置固定列
    this.fixedColumns.forEach(item => {
      this.tableColumns.push(item)
    })
    let currentDate = new Date()
    let currentYear = currentDate.getFullYear()
    this.yearOptions = [{label: (currentYear-1)+'年',data: (currentYear-1)}, {label: currentYear+'年',data: currentYear}]
    this.search.year = currentYear
    this.monthOptions = []
    for(let i = 1; i <= 12; i++){
      this.monthOptions.push({ label: i + '月', data: i })
    }
    this.search.month = currentDate.getMonth()+1
    if (checkPermission(['statistics_outside_work_log_export'])) {
      this.isExport = true
    }
    this.$nextTick(() => {
      this.initProvinceSelectData()
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.comptedTableHeight()
    })
    // 窗口发生变化的时候
    let me = this
    window.onresize = () => {
      return (() => {
        me.comptedTableHeight()
      })()
    }
  },
  methods: {
    themeBg(){
      let themeColor = this.$store.state.settings.theme
      return themeColor
    },
    // 初始省区下拉数据
    initProvinceSelectData(){
      loadAreaDataApi({ parentId: 1, isUserArea : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 计算表格高度
    comptedTableHeight () {
      let dHeight = document.body.clientHeight
      let searchHeight = this.$refs.searchCondition.clientHeight
      this.tableHeight = dHeight - searchHeight - 119 + 'px'
    },
    // 合并行处理方法
    // eslint-disable-next-line no-unused-vars
    workSpanMethod ({ row, column, rowIndex, columnIndex }) {
      let _this = this
      if (column.property === 'provinceNames') return this.mergeAction('provinceNames', rowIndex, column, _this.workRowMergeArray)
      if (column.property === 'cityNames') return this.mergeAction('cityNames', rowIndex, column, _this.workRowMergeArray)
      if (column.property === 'countyNames') return this.mergeAction('countyNames', rowIndex, column, _this.workRowMergeArray)
      if (column.property === 'userName') return this.mergeAction('userName', rowIndex, column, _this.workRowMergeArray)
      if (column.property === 'workDay') return this.mergeAction('workDay', rowIndex, column, _this.workRowMergeArray)
    },
    // 查询
    searchData () {
      this.loading = true
      this.workData = []
      this.workRowMergeArray = []
      loadOutsideWorkLogListDataApi(this.search).then(response => {
        this.loading = false
        if (response.data) {
          const { data } = response
          this.workData = data
          this.workRowMergeArray = this.rowMergeHandle(this.workNeedMergeArray, this.workData)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 导出数据API
    exportExcel () {
      if (!this.workData || this.workData.length === 0) {
        this.$message({ message: '无数据，不能导出', type: 'warning' })
        return
      }
      /* generate workbook object from table */
      //  判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去，
      let fix = document.querySelector('.el-table__fixed')
      let wb
      if (fix) {
        wb = XLSX.utils.table_to_book(document.querySelector('#work-table').removeChild(fix), { raw: true })
        document.querySelector('#work-table').appendChild(fix)
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector('#work-table'), { raw: true })
      }
      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '外勤工作日志表.xlsx')
      } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }

      return wbout
    }
  }
}
</script>
